import PostingPreviewsContainer from './posting_previews_container';

const PostingPreviews = PostingPreviewsContainer;
export default PostingPreviews;
